import { defineMessages, IntlProvider } from 'react-intl';

import CallQueue from './data-sources/CallQueue';
import Chart from '../models/Chart';
import ChartOption from '../models/ChartOption';
import Statistics from './data-sources/Statistics';

const messages = defineMessages({
  AGGREGATED: {
    id: 'AGGREGATED',
    defaultMessage: 'Aggregate',
  },
  PER_AGENT: {
    id: 'PER_AGENT',
    defaultMessage: 'Per Agent',
  },
  PER_QUEUE: {
    id: 'PER_QUEUE',
    defaultMessage: 'Per Queue',
  },
});

/**
 * Returns gauge chart manifest
 * @param locale
 * @returns {Chart}
 */
// eslint-disable-next-line import/prefer-default-export
export const initResponsiveGauge = (locale = 'en_us') => {
  const { intl } = new IntlProvider({
    locale,
    messages,
  }, {}).getChildContext();

  /**
   * default values for required query parameters
   * @type {{time_range: string}}
   */
  const queryParams = {
    time_range: '1_day',
    outOf: 100,
  };

  /**
   * Displays chart options to the user
   * type: timeRange displays an input and sets the start/end for the api request
   * type: queueFilter displays an input and sets the queue/s for the api request
   */
  const chartOptions = [
    new ChartOption({ type: 'timeRange', required: true }),
    new ChartOption({ type: 'queueFilter', required: false }),
    new ChartOption({ type: 'thresholds', required: false }),
    new ChartOption({ type: 'outOf', required: false }),
  ];

  const callQueue = new CallQueue(intl);
  const statistics = new Statistics(intl);

  const dataOptions = { ...callQueue.dataOptions, ...statistics.dataOptions };

  /**
   * @type {Chart}
   */
  return new Chart({
    type: 'ResponsiveGauge',
    chartOptions,
    dataOptions,
    queryParams,
    usesTimeRange: true,
    alertSupport: true,
  });
};
